module.exports = __webpack_public_path__ + "6001345dcca1e696f814154e2778a354.jpg";